// bao migrate skip
import "./../../factories/bao-dialog";
import * as ko from "knockout";
import Bao from "./../../services/bao-service";
import BaoDialog from "./../../factories/bao-dialog";
class ConfigurationItemNetworkTabDialog {
    constructor(ticketId: string, dialog: BaoDialog) {
        this.Dialog = dialog;
    }
    Bao = Bao;
    Dialog: BaoDialog;
    Sorting = ko.observable();
    SelectionModelRows = ko.observableArray<any>([]);
    loaded() {
    }
}
export default ConfigurationItemNetworkTabDialog;